export default function FlexibilityIcon() {
   return (
      <svg
         width="45"
         height="45"
         viewBox="0 0 45 45"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <mask
            id="mask0_5451_24607"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="45"
            height="45"
         >
            <path
               d="M44.6642 0.733185H0.617188V44.7802H44.6642V0.733185Z"
               fill="white"
            />
         </mask>
         <g mask="url(#mask0_5451_24607)">
            <path
               d="M30.3407 26.8462L30.3409 26.8463C30.9846 27.3283 31.1153 28.2409 30.6322 28.8825L30.6312 28.8838C30.3465 29.2673 29.9109 29.467 29.4655 29.467H29.4652C29.1508 29.4673 28.845 29.3652 28.594 29.1761L28.5936 29.1758L21.7699 24.058L21.7694 24.0577C21.4033 23.7845 21.1875 23.3522 21.1875 22.8933V12.6576C21.1875 11.8523 21.8382 11.2016 22.6435 11.2016C23.4488 11.2016 24.0995 11.8523 24.0995 12.6576V22.0402V22.1652L24.1995 22.2402L30.3407 26.8462Z"
               fill="#1F473E"
               stroke="#E0DEDC"
               strokeWidth="0.5"
            />
            <path
               d="M0.867188 22.7567C0.867188 10.7502 10.6342 0.983185 22.6407 0.983185C34.6472 0.983185 44.4142 10.7502 44.4142 22.7567C44.4142 34.7632 34.6472 44.5302 22.6407 44.5302C10.6342 44.5302 0.867188 34.7632 0.867188 22.7567ZM3.77903 22.7567C3.77903 33.1559 12.2415 41.6184 22.6407 41.6184C33.0399 41.6184 41.5024 33.1559 41.5024 22.7567C41.5024 12.3575 33.0417 3.89503 22.6407 3.89503C12.2415 3.89503 3.77903 12.3575 3.77903 22.7567Z"
               fill="#1F473E"
               stroke="#E0DEDC"
               strokeWidth="0.5"
            />
         </g>
      </svg>
   )
}
